<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="37" viewBox="0 0 30 37" fill="none">
    <path
      d="M15 10C16.85 10 18.3333 8.5 18.3333 6.66667C18.3333 6.03333 18.1667 5.45 17.85 4.95L15 0L12.15 4.95C11.8333 5.45 11.6667 6.03333 11.6667 6.66667C11.6667 8.5 13.1667 10 15 10ZM22.6667 26.65C21.6804 25.6637 20.0742 25.6683 19.0833 26.65C16.9167 28.8167 13.1167 28.8333 10.9333 26.65C9.94577 25.6624 8.33 25.6716 7.33333 26.65C6.25 27.7333 4.8 28.3333 3.26667 28.3333C2.05 28.3333 0.933333 27.95 0 27.3167V35C0 35.9167 0.75 36.6667 1.66667 36.6667H28.3333C29.25 36.6667 30 35.9167 30 35V27.3167C29.0667 27.95 27.95 28.3333 26.7333 28.3333C25.2 28.3333 23.75 27.7333 22.6667 26.65ZM25 15H16.6667V11.6667H13.3333V15H5C2.23333 15 0 17.2333 0 20V22.5667C0 24.3667 1.46667 25.8333 3.26667 25.8333C4.13333 25.8333 4.96667 25.5 5.56667 24.8833C7.53321 22.926 10.7214 22.9214 12.6833 24.8833C13.9167 26.1167 16.0667 26.1167 17.3 24.8833C19.2665 22.926 22.4547 22.9214 24.4167 24.8833C25.0333 25.5 25.85 25.8333 26.7167 25.8333C28.5167 25.8333 29.9833 24.3667 29.9833 22.5667V20C30 17.2333 27.7667 15 25 15Z"
      fill="url(#paint0_linear_47_5644)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_47_5644"
        x1="0"
        y1="0"
        x2="36.0142"
        y2="29.2656"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
